import type { SVGAttributes } from 'react';

export function FilterYearIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<rect width="24" height="24" rx="4" fill="currentColor" fillOpacity="0.1" />
			<path
				d="M9.33337 5.33331V7.33331"
				stroke="currentColor"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.6666 5.33331V7.33331"
				stroke="currentColor"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.6667 6.33331C16.8867 6.45331 18 7.29998 18 10.4333V14.5533C18 17.3 17.3333 18.6733 14 18.6733H10C6.66667 18.6733 6 17.3 6 14.5533V10.4333C6 7.29998 7.11333 6.45998 9.33333 6.33331H14.6667Z"
				stroke="currentColor"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.8333 15.7333H6.16663"
				stroke="currentColor"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 9.5C11.18 9.5 10.4867 9.94667 10.4867 10.8133C10.4867 11.2267 10.68 11.54 10.9734 11.74C10.5667 11.98 10.3334 12.3667 10.3334 12.82C10.3334 13.6467 10.9667 14.16 12 14.16C13.0267 14.16 13.6667 13.6467 13.6667 12.82C13.6667 12.3667 13.4334 11.9733 13.02 11.74C13.32 11.5333 13.5067 11.2267 13.5067 10.8133C13.5067 9.94667 12.82 9.5 12 9.5ZM12 11.3933C11.6534 11.3933 11.4 11.1867 11.4 10.86C11.4 10.5267 11.6534 10.3333 12 10.3333C12.3467 10.3333 12.6 10.5267 12.6 10.86C12.6 11.1867 12.3467 11.3933 12 11.3933ZM12 13.3333C11.56 13.3333 11.24 13.1133 11.24 12.7133C11.24 12.3133 11.56 12.1 12 12.1C12.44 12.1 12.76 12.32 12.76 12.7133C12.76 13.1133 12.44 13.3333 12 13.3333Z"
				fill="currentColor"
			/>
		</svg>
	);
}
